// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"SurveyFromTemplateModal_modal-body__2NINn"};